const FILE_WRITE_TRANSITIONS = [
  (path, next) => `\`${path}\` is saved. Up next: \`${next}\`.`,
  (path, next) => `Finished \`${path}\`. Moving on to \`${next}\`.`,
  (path, next) => `\`${path}\` is in place — time for \`${next}\`.`,
  (path, next) => `Done with \`${path}\`. Now writing \`${next}\`.`,
  (path, next) => `\`${path}\` is ready. Onto \`${next}\`.`,
]

/**
 * @param {string} donePhrase
 * @param {string} [nextPhrase]
 * @param {number} [index]
 */
export function buildStepNarration(donePhrase, nextPhrase, index = 0) {
  if (!nextPhrase?.trim()) return donePhrase
  const templates = [
    (done, next) => `${done} Up next: ${next}.`,
    (done, next) => `${done} Moving on to ${next}.`,
    (done, next) => `${done} Now onto ${next}.`,
    (done, next) => `${done} Then ${next}.`,
    (done, next) => `${done} From here, ${next}.`,
  ]
  return templates[index % templates.length](donePhrase, nextPhrase)
}

/**
 * @param {string} relPath
 * @param {string} [nextRelPath]
 * @param {number} [index]
 */
export function buildFileWriteNarration(relPath, nextRelPath, index = 0) {
  if (!nextRelPath) return `\`${relPath}\` is saved.`
  return FILE_WRITE_TRANSITIONS[index % FILE_WRITE_TRANSITIONS.length](relPath, nextRelPath)
}
